import src from '../assets/thegreenroomigc.png';
import { imageLogo } from './imageLogo';

/**
 * The Green Room IGC — horizontal lockup on transparency.
 * Was a 1563² raster wrapped in <svg><image>, cropped at render time via the
 * registry's logoViewBox; the crop ('90 520 1450 470') is now baked into the
 * asset. 12KB quantized.
 */
export const TheGreenRoomIGCLogo = imageLogo({
  src,
  width: 1000,
  height: 324,
  alt: 'The Green Room Indoor Golf Club',
});
